import { render, staticRenderFns } from "./CourseStructure.vue?vue&type=template&id=6006ce20&"
import script from "./CourseStructure.vue?vue&type=script&lang=js&"
export * from "./CourseStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports